<template>
    <!-- background-attachment: fixed ne dela na mobilnih napravah. to je workaround za pravilen prikaz ozadja -->
    <div class="d-xl-none" style="position: fixed; z-index: -1; left: 50%; transform: translateX(-50%); bottom: 0;">
<!--        <img :data-src="image" alt="Ozadje" class="min-vw-100 lazy" style="max-height: 100vh; max-width: 150vw">-->
        <img :data-src="mobileImage || image" alt="Ozadje" class="lazy" :style="{ 'height': mobileHeight }">
    </div>
    <!-- end -->
</template>

<script>
	export default {
		name: "Background",
		props: {
			image: {
				type: String,
				required: true,
			},
            mobileImage: {
				type: String,
                required: false,
            },
            mobileHeight: {
				type: String,
                required: false,
                default: "100vh",
            },
			setBackgroundImage: {
				type: Boolean,
				required: false,
				default: false,
			},
		},
		data() {
			return {
				imageWasLoaded: false,
			}
		},
		watch: {
			setBackgroundImage() {
				this.changeBodyBackground();
			}
		},
		methods: {
			changeBodyBackground() {
				const isDesktop = window.matchMedia("(min-width: 1200px)").matches;

				if (!this.imageWasLoaded && !isDesktop) {
					this.imageWasLoaded = true;
					document.querySelectorAll('.lazy').forEach(element => {
						element.classList.remove('lazy');
						element.src = element.dataset.src;
                    });
                }

				document.body.style.backgroundImage = isDesktop ? `url('${this.image}')` : 'none';
			}
		},
		mounted() {
			this.$nextTick(() => {
				window.addEventListener('resize', () => {
					this.changeBodyBackground();
				});
			});
		},
	}
</script>

<style scoped>

</style>